import React from "react"
import {
    Snackbar 
} from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useSettings } from "Context/Settings/useSettings";


const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  

const SnackBar = () =>{
    const settings = useSettings()

    const handleClose =() =>{
        if (settings.snackBar.callBack) settings.snackBar.callBack()
        
        settings.setSnackBar((prev) => ({
            message: prev.message,
            type: prev.type,
            open: false
        }))
    }

    return(
        <div>
            <Snackbar open={settings.snackBar.open} autoHideDuration={6000} onClose={handleClose} style={{marginBottom:'25px'}}>
                <Alert onClose={handleClose} severity={ settings.snackBar.type } sx={{ width: '100%' }}>
                    { settings.snackBar.message }
                </Alert>
            </Snackbar>
        </div>
    )
}
export default SnackBar;